import * as style from "./style";

export const Footer = () => {
  return (
    <style.footer>
      <small>
        <a href="https://www.exchangerate-api.com">
          Rates By Exchange Rate API
        </a>
      </small>
    </style.footer>
  );
};
